module.exports = __webpack_public_path__ + "media/images/SIQ_screenshot_1-37b470b64296ec368af0db3c2eed5c8c.png";